
        import '/home/builduser/work/575538235ca6a4de/santa-editor/packages/ai/ui/businessTypeInput/businessTypeInput.scss.css.virtualfile';
        module.exports = {"input":"_input_mm0b8_7"};